import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';

export class SetMenuHeight extends Component {
    static TypeName = 'set-menu-height';

    @property.float(1.6)
    vrHeight = 1.6;

    @property.float(0)
    nonVrHeight = 0;

    private _originalPosition = new Float32Array(3);

    start(): void {
        this.object.getPositionLocal(this._originalPosition);
    }
    onActivate(): void {
        this.engine.onXRSessionEnd.add(this._onXRSessionEnd);
        this.engine.onXRSessionStart.add(this._onXRSessionStart);
    }
    onDeactivate(): void {
        this.engine.onXRSessionEnd.remove(this._onXRSessionEnd);
        this.engine.onXRSessionStart.remove(this._onXRSessionStart);
    }
    private _onXRSessionStart = () => {
        this.object.setPositionLocal([
            this._originalPosition[0],
            this._originalPosition[1] + this.vrHeight,
            this._originalPosition[2],
        ]);
    };
    private _onXRSessionEnd = () => {
        this.object.setPositionLocal([
            this._originalPosition[0],
            this._originalPosition[1] + this.nonVrHeight,
            this._originalPosition[2],
        ]);
    };
}
